import React from 'react'
import { CSVLink } from 'react-csv'
import styled from 'styled-components/macro'
import { buildCsvString } from '../../utils/csv'
import { VAT_PERCENTAGE, VAT_RATE } from '../../config'
import useStockRoleCapabilities from 'src/hooks/useStockRoleCapabilities'

const ValuationCSV = ({
  stockTakeProducts,
  stockTake,
  dateRange,
  totals,
  endpoint,
}) => {
  const { canViewExpectedAndVariance: canViewSensitiveColumns } =
    useStockRoleCapabilities()
  const isEndPointWastage = endpoint === 'wastage-report'
  const optionalText = value =>
    String(value ?? '').trim() || 'No details provided'

  const rangeInString =
    dateRange?.from && dateRange?.to
      ? `${dateRange.from} - ${dateRange.to}`
      : ''
  const headersStockTakeValuation = [
    'Product',
    'Size',
    'UoM',
    'Supplier',
    'Price',
    ...(canViewSensitiveColumns ? ['Prev qty', 'Received'] : []),
    'Stock Amount',
    'Stock Value',
    'Wastage',
    'Wastage value',
    'Wastage comment',
    'Weighted',
    'VAT',
    'Net',
    'Gross',
  ]
  const rows = []
  rows.push([`Report ${rangeInString}`])
  rows.push(['Count type', stockTake?.countType || 'MAIN'])
  rows.push(['Count notes', optionalText(stockTake?.countNotes)])
  rows.push([])
  rows.push(headersStockTakeValuation)
  stockTakeProducts.forEach(product => {
    const currentQuantity = isEndPointWastage
      ? product.wastage
      : product.inStock
    const row = [
      optionalText(product.title),
      optionalText(product.size),
      optionalText(product.UoM),
      optionalText(product.supplierTitle),
      product.price,
      ...(canViewSensitiveColumns
        ? [product.lastQuantity, product.qtySinceLastStockTake]
        : []),
      currentQuantity,
      product.hasVat
        ? product.price * product.inStock * VAT_RATE
        : product.price * product.inStock,
      product.wastage,
      product.hasVat
        ? product.price * product.wastage * VAT_RATE
        : product.price * product.wastage,
      optionalText(product.wastageComment),
      product.UoM
        ? product.UoM.toLowerCase() === 'kg' ||
          product.UoM.toLowerCase() === 'g'
        : false,
      product.hasVat ? VAT_PERCENTAGE * (currentQuantity * product.price) : 0,
      product.price * currentQuantity,
      product.hasVat
        ? VAT_RATE * currentQuantity * product.price
        : currentQuantity * product.price,
    ]
    rows.push(row)
  })
  const totalRow = new Array(headersStockTakeValuation.length).fill('')
  totalRow[0] = 'Totals:'
  totalRow[headersStockTakeValuation.length - 3] = `£${totals.VAT}`
  totalRow[headersStockTakeValuation.length - 2] = `£${totals.net}`
  totalRow[headersStockTakeValuation.length - 1] = `£${totals.gross}`
  rows.push([], [], totalRow)

  const csvString = buildCsvString(rows)

  return (
    <DownloadCsvLink
      data={csvString}
      filename={`oms-${
        isEndPointWastage ? 'wastage' : 'valuation'
      }-stock-take${rangeInString}.csv`}
    >
      Download CSV
    </DownloadCsvLink>
  )
}

const DownloadCsvLink = styled(CSVLink)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  height: 36px;
  padding: 0 14px;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  background: #fff;
  color: inherit;
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  text-decoration: none;
  cursor: pointer;
`

export default ValuationCSV
